import type { IconProps } from './types';
import './icons.css';

export default function Dots({
  width,
  height,
  className = '',
}: IconProps): React.JSX.Element {
  return (
    <svg
      width={width || 16}
      height={height || 16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`icon icon-dots ${className || ''}`}
    >
      <path
        fill="currentColor"
        d="M11.333 8A1.333 1.333 0 1 1 14 8a1.333 1.333 0 0 1-2.667 0ZM6.666 8A1.334 1.334 0 1 1 9.334 8 1.334 1.334 0 0 1 6.666 8ZM2 8a1.333 1.333 0 1 1 2.666 0A1.333 1.333 0 0 1 2 8Z"
      />
    </svg>
  );
}
